<template>
    <el-config-provider :locale="zhCn">
        <RouterView />

        <Teleport to="body">
            <Transition name="fade">
                <div
                    v-if="versionDrawerVisible"
                    class="fixed z-9999 w-80 bottom-5 right-5 p-5 bg-[var(--el-bg-color-overlay)] shadow-[var(--el-box-shadow-light)] flex flex-col justify-center items-center"
                >
                    <img class="w-16 h-16 object-cover" src="./assets/imgs/logo_text.png" alt="" />
                    <el-text class="m-y-5">检测到有新版本，请刷新获取最新版本</el-text>
                    <div>
                        <el-button type="primary" plain @click="refreshHandle" :icon="Refresh">刷新</el-button>
                    </div>
                </div>
            </Transition>
        </Teleport>
    </el-config-provider>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { Refresh } from '@element-plus/icons-vue';
import { useDebounceFn } from '@vueuse/core';

import emitter from '@/utils/mitt';

//
const versionDrawerVisible = ref(false);
const refreshPath = ref('');
emitter.on('showVersionDrawer', (path: any) => {
    versionDrawerVisible.value = true;
    refreshPath.value = path;
});

function refreshHandle() {
    window.location = refreshPath.value as any;
}

// fix error: ResizeObserver loop completed with undelivered notifications.
const _ResizeObserver = window.ResizeObserver;
if (_ResizeObserver && !window.__resizeObserverPatched) {
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback: ResizeObserverCallback) {
            callback = useDebounceFn(callback);
            super(callback);
        }
    };
    (window as any).__resizeObserverPatched = true;
}

onMounted(() => {
    window.document.getElementById('beforeLoadedLoading')?.remove();
});
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(200px) scale(0.5);
    opacity: 0;
}
</style>
